class BrowserButtons extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isMobile = {
      Android: navigator.userAgent.match(/Android/i),
      iOS: navigator.userAgent.match(/iPhone|iPad|iPod/i),
    }

    this.init()
  }

  init () {
    this.els.button?.elements.forEach(element => {
      if (element.dataset.type === 'any') {
        const visibleCount = this.els.button?.elements.some(element => {
          return element.ariaHidden !== 'true'
        })
        element.ariaHidden = visibleCount
      } else {
        element.ariaHidden = this.isMobile[element.dataset.type] == null
      }
    })
  }
}

if (!customElements.get('browser-buttons')) {
  customElements.define('browser-buttons', BrowserButtons)
}
